import type { ReactNode } from 'react';
import { useIsMobile } from '@/lib/useMediaQuery';
import { Dialog } from './Dialog';
import { Sheet } from './Sheet';

type Props = { open: boolean; onOpenChange: (o: boolean) => void; title: string; description?: string; children: ReactNode; footer?: ReactNode; size?: 'sm' | 'md' | 'lg' };

/** A dialog on desktop, a bottom sheet on phones. One call site, two shapes - so no screen carries both. */
export function Modal({ size = 'md', ...props }: Props) {
  return useIsMobile() ? <Sheet {...props} /> : <Dialog {...props} size={size} />;
}
